import { render } from "./homeView.vue?vue&type=template&id=d7faede2&scoped=true"
import script from "./homeView.vue?vue&type=script&lang=js"
export * from "./homeView.vue?vue&type=script&lang=js"

import "./homeView.vue?vue&type=style&index=0&id=d7faede2&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/coipor/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7faede2"]])

export default __exports__